export default function isTextInputElement(e: HTMLInputElement) {
    return (
        e &&
        (e.isContentEditable ||
            e.tagName.toLowerCase() == 'textarea' ||
            (e.tagName.toLowerCase() == 'input' && e.type.toLowerCase() == 'text'))
    );
}
